// 语言，需要后期补齐
const langPrefix = window.g_lang || "";

function jumpTo(params = {}) {
  const { link = "", name = "_blank", ...otherConfig } = params;

  if (!link) return;

  const jumpLink = link.includes("https") ? link : `${langPrefix}${link}`;

  if (!window.$$device_type) {
    window.open(jumpLink, name, otherConfig);
  } else {
    if (+window.$$device_type === 1) {
      window.gateio.openWebUrl(jumpLink);
    } else {
      window.webkit.messageHandlers.openWebUrl.postMessage({ jumpLink });
    }
  }
}

function getParamByUrl(name) {
  const url = new URL(window.location.href);
  const param = url.searchParams.get(name);
  return param != null ? decodeURIComponent(param) : null;
}

/**
 * @description: 打点
 * @param {*} window
 * @param {*} dataEventName 事件名称
 * @param {*} collectParams 对象：{属性名称: 属性值}
 */
function collectFunc({ eventName, params }) {
  if (!eventName) return;
  if (window.collectEvent) {
    window.collectEvent("beconEvent", eventName, params ? { ...params } : "");
  }
}

// Crypto Holder（持币人）
// Astronaut（宇航员）
// Miner（矿工）
// Merchant（商人）
// Whale（鲸鱼）
// Beginner（新手）

const nftStyleList = [
  "Crypto Holder",
  "Astronaut",
  "Miner",
  "Merchant",
  "Whale",
  "Beginner",
];

export { nftStyleList, jumpTo, getParamByUrl, collectFunc };
